import { makeStyles } from 'tss-react/mui';
import { histowizTheme } from 'themes/defaultMuiTheme';

export const useAnnotationsPageStyles = makeStyles()(() => ({
  headerContainer: {
    padding: '1.125rem',
    width: '100%',
  },
  exportButton: {
    marginLeft: 'auto',
  },
  pagination: {
    marginLeft: '1rem',
    ' > ul': {
      justifyContent: 'flex-end',
      '& .Mui-selected': {
        borderColor: histowizTheme.palette.secondary.main,
      },
    },
  },
  paginationSection: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  spinnerContainer: {
    height: '50vh',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
